module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }